import React from "react";

import {
  Input,
  Button,
  Switch,
  Checkbox,
  Row,
  Col,
  Collapse,
  InputNumber,
  Radio, Form, Select
} from "antd";
const { Panel } = Collapse;
const { Option } = Select;

class FormTwo extends React.Component {

  formTwoOnFinish = e => {
    this.props.formTwoOnFinish(e);
  }
  formTwoOnFinishFailed = e => {
    console.log(e, "formOneOnFinishFailed");
  }
  render() {
    const { applicationsMapByAppName, dataOne } = this.props;
    return (
      <div className="is_form_2">
        <Form
          labelAlign="left"
          labelCol={{
            xxl: { span: 3 },
            xl: { span: 4 },
            lg: { span: 5 },
            md: { span: 5 },
            sm: { span: 5 },
            xs: { span: 24 },
          }}
          wrapperCol={{
            xxl: { span: 21 },
            xl: { span: 20 },
            lg: { span: 19 },
            md: { span: 19 },
            sm: { span: 19 },
            xs: { span: 24 },
          }}

          ref={this.props.formRef}
          onFinish={this.formTwoOnFinish}
          onFinishFailed={this.formTwoOnFinishFailed}

          scrollToFirstError={true}

        // initialValues={{
        //   '5f604124e243cd22b1b8547c': {status_view : null }
        // }}

        >

          <div className="is_form_2_top_bar">
            <Row>
              <Col sm={12}>
                <div className="is_form_2_top_bar_a">
                  {dataOne && dataOne.role && dataOne.role.role_name ? (
                    <h3>{dataOne.role.role_name}</h3>
                  ) : null}
                </div>
              </Col>

            </Row>
          </div>

          {applicationsMapByAppName["myDocs"] && applicationsMapByAppName["myDocs"]._id ? (
            <Collapse defaultActiveKey={["mydocs_1"]} expandIconPosition="end">
              <Panel header="MyDocs" key="mydocs_1">
                <div className="is_form_2_a">
                  <div className="is_form_2_aa">
                    <Row>
                      <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                        <label>Tabular View</label>
                      </Col>

                      <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                        <Form.Item
                          name={[applicationsMapByAppName["myDocs"]._id, 'tabular_view']}
                          noStyle={true}
                          valuePropName="checked"
                          initialValue={false}
                        >
                          <Switch />
                        </Form.Item>

                      </Col>
                    </Row>
                  </div>
                </div>
              </Panel>
            </Collapse>
          ) : null}

          {applicationsMapByAppName["Compliance"] && applicationsMapByAppName["Compliance"]._id ? (
            <Collapse defaultActiveKey={["compliance_1"]} expandIconPosition="end">
              <Panel header="Compliance" key="compliance_1">
                <div className="is_form_2_a">
                  {/* <div className="is_form_2_aa">
                    <Row>
                      <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                        <label>Default Load</label>
                      </Col>
                      <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                        <Row>

                          <Col xxl={2} xl={3} lg={4} sm={6}>
                            <Form.Item
                              name={[applicationsMapByAppName["Compliance"]._id, 'default_load']}
                              noStyle={true}
                              // initialValue={null}
                            >
                              <InputNumber style={{ width: "100%" }} min={1} max={99999} precision={0}/>
                            </Form.Item>
                          </Col>

                        </Row>
                      </Col>
                    </Row>
                  </div> */}
                  <div className="is_form_2_aa">
                    <Row>
                      <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                        <label>Status View</label>
                      </Col>
                      <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                        <Row>
                          <Col xxl={4} xl={6} lg={6} sm={19} xs={24}>
                            <Form.Item
                              name={[applicationsMapByAppName["Compliance"]._id, 'status_view']}
                              noStyle={true}
                              initialValue="All"
                            >
                              <Select >
                                <Option value="All">All</Option>
                                <Option value="Report Status">Report Status</Option>
                                <Option value="Signature Status">Signature Status</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                  <div className="is_form_2_aa">
                    <Row>
                      <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                        <label>Date View</label>
                      </Col>
                      <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                        <Row>
                          <Col xxl={4} xl={6} lg={6} sm={19} xs={24}>
                            <Form.Item
                              name={[applicationsMapByAppName["Compliance"]._id, 'date_view']}
                              noStyle={true}
                              initialValue="vertical"
                            >
                              <Select >
                                <Option value="horizontal">Horizontal</Option>
                                <Option value="vertical">Vertical</Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>

                </div>
              </Panel>
            </Collapse>
          ) : null}

          <div style={{ marginBottom: 20 }}></div>

          <div style={{ paddingTop: 20, textAlign: "center" }}>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}



export default FormTwo;
